import * as React from 'react';
import { useManage2faAuthentication } from './Manage2faEndpoints';
import {
    Avatar,
    Box,
    Card,
    CardHeader,
    CardContent,
    Dialog,
    DialogContent,
    Menu,
    MenuItem,
    Typography,
    IconButton,
    Slide
} from '@mui/material';
import { green, grey } from '@mui/material/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';

import { Manage2faAuthenticatorResetAppDialog } from './Manage2faAuthenticatorResetAppDialog';
import { Manage2faSmsResetDialog } from './Manage2faSmsResetDialog';
import Manage2faStepper from './Manage2faStepper';

const mfaMethod = {
    EMAIL: 'email',
    PHONE: 'phone',
    AUTHENTICATOR: 'authenticator'
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function Manage2faOptions(props) {
    const authentication = useManage2faAuthentication();
    const [openResetAuthenticator, setOpenResetAuthenticator] = React.useState(false);
    const [openResetSms, setOpenResetSms] = React.useState(false);
    const [open2faSetup, setOpen2faSetup] = React.useState(false);
    const [method, setMethod] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event, newMethod) => {
        setMethod(newMethod);
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClickOpen2faSetup = (method) => {
        setMethod(method);
        setOpen2faSetup(true);
    };

    const handleClose2faSetup = () => {
        //setReMutateUrls(true);
        setOpen2faSetup(false);
    };


    const handleResetAuthenticatorClickOpen = () => {
        setOpenResetAuthenticator(true);
    };

    const handleResetAuthenticatorClose = () => {
        setOpenResetAuthenticator(false);
    };

    const handleResetAuthenticatorConfirm = (triggerSetup) => {
        //setReMutateUrls(true);
        handleResetAuthenticatorClose();

        if (triggerSetup) {
            handleClickOpen2faSetup('authenticator');
        }
    };

    const handleResetSmsClickOpen = () => {
        setOpenResetSms(true);
    };

    const handleResetSmsClose = () => {
        setOpenResetSms(false);
    };

    const handleResetSmsConfirm = (triggerSetup) => {
        //setReMutateUrls(true);
        handleResetSmsClose();

        if (triggerSetup) {
            handleClickOpen2faSetup('sms');
        }
    };


    // on Change
    const handleTwoFactorPhoneChange = (event) => {
        if (authentication.result?.phoneNumberConfirmed) {
            handleResetSmsClickOpen();
        }
        else {
            handleClickOpen2faSetup('sms');
        }
    }

    // on Change
    const handleTwoFactorAuthenticatorChange = (event) => {
        if (authentication.result?.hasAuthenticator) {
            handleResetAuthenticatorClickOpen();
        }
        else {
            handleClickOpen2faSetup('authenticator');
        }
    }

    const handleConfigure = () => {
        if (method === mfaMethod.AUTHENTICATOR) {
            handleTwoFactorAuthenticatorChange();
        }
        else if (method === mfaMethod.PHONE) {
            handleTwoFactorPhoneChange();
        }
        handleClose();
    }

    return (
        <Box>
        <Card sx={{width: '100%', mt: 2}} elevation={3}>
            <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: green[500] }} aria-label="email">
                        <EmailIcon />
                    </Avatar>
                    }
                title="Email"
                subheader={authentication.result?.emailConfirmed ? "Configured" : "Not Configured"}
            />
            <CardContent>
                <Typography variant="body2">
                    Receive a one-time verification code on sign-in, through your email account.
                </Typography>
            </CardContent>
        </Card>
        <Card sx={{width: '100%', mt: 2}} elevation={3}>
            <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: authentication.result?.phoneNumberConfirmed ? green[500] : grey[500] }} aria-label="phone">
                        <PhoneIcon />
                    </Avatar>
                    }
                action={
                <IconButton aria-label="settings" onClick={(event) => handleClick(event, mfaMethod.PHONE)}>
                    <MoreVertIcon />
                </IconButton>
                }
                title="Phone"
                subheader={authentication.result?.phoneNumberConfirmed ? "Configured" : "Not Configured"}
            />
            <CardContent>
                <Typography variant="body2">
                    Receive a one-time verification code on sign-in, through text message (SMS).
                </Typography>
            </CardContent>
        </Card>
        <Card sx={{width: '100%', mt: 2}} elevation={3}>
            <CardHeader
                avatar={
                    <Avatar sx={{ bgcolor: authentication.result?.hasAuthenticator ? green[500] : grey[500] }} aria-label="authenticator app">
                        <SafetyCheckIcon />
                    </Avatar>
                    }
                action={
                <IconButton aria-label="settings" title='quthapp' onClick={(event) => handleClick(event, mfaMethod.AUTHENTICATOR)}>
                    <MoreVertIcon />
                </IconButton>
                }
                title="Authenticator App"
                subheader={authentication.result?.hasAuthenticator ? "Enabled" : "Not Configured"}
            />
            <CardContent>
                <Typography variant="body2">
                    Use a one-time authentication code on sign-in, through your chosen Authenticator App.
                </Typography>
            </CardContent>
        </Card>
        <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
            'aria-labelledby': 'basic-button',
            }}
        >
            <MenuItem onClick={handleConfigure}>Configure</MenuItem>
        </Menu>
        <Manage2faAuthenticatorResetAppDialog
                open={openResetAuthenticator}
                onConfirm={(triggerSetup) => {
                    handleResetAuthenticatorConfirm(triggerSetup);
                }}
                onClose={handleResetAuthenticatorClose}
            />
            <Manage2faSmsResetDialog
                open={openResetSms}
                onConfirm={(triggerSetup) => {
                    handleResetSmsConfirm(triggerSetup);
                }}
                onClose={handleResetSmsClose}
            />
            <Dialog fullWidth
                open={open2faSetup}
                TransitionComponent={Transition}
            >
                <DialogContent>
                    <Manage2faStepper
                        method={method}
                        goBack={handleClose2faSetup}
                        profilePhoneNumber={props.phoneNumber}
                    />
                </DialogContent>
            </Dialog>
    </Box>
    );
}